import React from 'react'

const LoadingIndicator = () => {
    return (
        <div data-w-id="846a3e6d-3dad-6cc5-05fa-521409a26ff0" className="pageloading d-block"></div>
    )
}

export default LoadingIndicator
